import * as ACTION_TYPES from '../constants/types';

const initialState = {
    productCategoryList: [],
    productCategoryInfo: {},
    productCategoryLoop: [],
    error: null
}

const productCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.GET_PRODUCT_CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                productCategoryList: action.payload.data.list ? action.payload.data.list : [],
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.GET_PRODUCT_CATEGORY_LIST_ERROR:
            return {
                ...state,
                productCategoryList: [],
            }
        case ACTION_TYPES.GET_PRODUCT_CATEGORY_INFO_SUCCESS:
            return {
                ...state,
                productCategoryInfo: action.payload.data,
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.GET_PRODUCT_CATEGORY_INFO_ERROR:
            return {
                ...state,
                productCategoryInfo: {},
            }
        case ACTION_TYPES.GET_PRODUCT_CATEGORY_LIST_DD_SUCCESS:
            return {
                ...state,
                productCategoryLoop: action.payload.data.list ? action.payload.data.list : [],
                message: action.payload.message,
                error: null
            }
        default:
            return state;
    }
}
export default productCategoryReducer